import React from 'react';
import { Block, CourseCardSkeletonGroup } from '@udemy/react-reveal-components';
import styles from "./bundle-unit-skeleton.module.css";
export const BundleUnitSkeleton = ({
  isSingleSelectableUnit = false
}) => /*#__PURE__*/React.createElement("section", {
  "data-testid": "bundle-unit-skeleton"
}, /*#__PURE__*/React.createElement(CourseCardSkeletonGroup, {
  cardCountPerRow: 1,
  rowCount: 2,
  size: "large",
  withTitle: true
}), !isSingleSelectableUnit && /*#__PURE__*/React.createElement(Block, {
  className: styles['footer-block']
}));
//# sourceMappingURL=bundle-unit-skeleton.react-component.js.map